
import { Routes, Route } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import Header from "./components/Header";
import TopBar from "./components/TopBar";
import LogoBar from "./components/LogoOverlay";
import PublicDisclosure from "./pages/PublicDisclosure";
import NavBar from "./components/NavBar";
import PopUpModal from "./components/PopUpModal";
import Hero from "./pages/Hero";
import Welcome from "./pages/Welcome";
import Features from "./pages/Features";
import Services from "./pages/Services";
import VisionMission from "./pages/VisionMission";
import Footer from "./pages/Footer";
import Erp from "./pages/Erp";
import AboutUs from "./pages/AboutUs";
import ChairMen from "./pages/ChairMen";
import Director from "./pages/Director";
import Principal from "./pages/Principal";
import Faculty from "./pages/Faculty";
import History from "./pages/History";
import SchoolInfo from "./pages/SchoolInfo";
import SchoolManagement from "./pages/SchoolManagement";
import VisitingDigitaries from "./pages/VisitingDigitaries";
import Admission from "./pages/Admission";
import AgeCriteria from "./pages/AgeCriteria";
import AdmissionProcess from "./pages/AdmissionProcess";
import AdmissionFee from "./pages/AdmissionFee";
import AdmissionRequirement from "./pages/AdmissionRequirement";
import PlaywayKindergarden from "./pages/PlaywayKindergarden";
import PrimaryCurriculum from "./pages/PrimaryCurriculum";
import MiddleCurriculum from "./pages/MiddleCurriculum";
import HighCurriculum from "./pages/HighCurriculum";
import Classroom from "./pages/Classroom";
import Library from "./pages/Library";
import Labs from "./pages/Labs";
import Sports from "./pages/Sports";
import Transportation from "./pages/Transportation";
import HealthCare from "./pages/HealthCare";
import Music from "./pages/Music";
import CoCurriculum from "./pages/CoCurriculum";
import EducationTrips from "./pages/EducationTrips";
import MorningAssembly from "./pages/MorningAssembly";
import Value from "./pages/Value";
import Contact from "./pages/Contact";
import NurturingTalents from "./pages/NuturingTalents";
import AdmissionForm from "./pages/Admission";
import Awards from "./pages/Awards";
import Playway from "./pages/Playway";
import SchoolCurriculum from "./pages/SchoolCurriculum";
import Secondary from "./pages/Secondary";
import SeniorSecondary from "./pages/SeniorSecondary";
import Security from "./pages/Security";
import Faqs from "./pages/Faqs";
import Career from "./pages/Career";
import FeedBack from "./pages/FeedBack";
import Ptm from "./pages/Ptm";
import SchoolHouse from "./pages/SchoolHouse";
import MobileNav from "./components/MobileNav";

// ================= COMMON LAYOUT =================

function Layout({ children }) {
  return (
    <div className="min-h-screen">
      <PopUpModal />

      <Header />
      <TopBar />
      <LogoBar />
      <NavBar />
      <MobileNav />

      {children}

      <Footer />

      {/* ================= CONTACT BUTTON ================= */}

      <a
        href="/contact"
        aria-label="Contact Us"
        className="
          fixed left-3 bottom-24
          sm:left-4 sm:bottom-24
          md:bottom-6
          z-[99999]
          flex items-center justify-center gap-2
          bg-[#07294d] hover:bg-[#0b3d6d]
          text-white
          px-4 py-3
          sm:px-5 sm:py-3
          md:px-6 md:py-4
          rounded-full
          shadow-xl hover:shadow-2xl
          transition-all duration-300
          hover:-translate-y-1
          active:scale-95
          max-w-[calc(100vw-100px)]
        "
      >
        <span className="text-lg sm:text-xl" aria-hidden="true">
          📞
        </span>

        <span className="text-sm sm:text-base font-semibold whitespace-nowrap">
          Contact Us
        </span>
      </a>

      {/* ================= WHATSAPP BUTTON ================= */}

      <a
        href="https://wa.me/919876543210"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with us on WhatsApp"
        className="
          fixed right-3 bottom-5
          sm:right-5 sm:bottom-5
          md:right-6 md:bottom-6
          z-[99999]
          flex items-center justify-center
          w-12 h-12
          sm:w-14 sm:h-14
          md:w-16 md:h-16
          rounded-full
          bg-[#25D366] hover:bg-[#1ebe5d]
          text-white
          text-2xl sm:text-3xl
          shadow-xl hover:shadow-2xl
          hover:scale-110
          transition-all duration-300
          border-[3px] sm:border-4 border-white
          active:scale-95
        "
      >
        <FaWhatsapp />
      </a>
    </div>
  );
}

// ================= HOME PAGE =================

function HomePage() {
  return (
    <Layout>
      <Hero />
      <Welcome />
      <Features />
      <NurturingTalents />
      <Services />
      <VisionMission />
    </Layout>
  );
}

// ================= APP =================

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />

      <Route path="/about" element={<Layout><AboutUs /></Layout>} />
      <Route path="/chairmen" element={<Layout><ChairMen /></Layout>} />
      <Route path="/director" element={<Layout><Director /></Layout>} />
      <Route path="/principal-message" element={<Layout><Principal /></Layout>} />
      <Route path="/faculty" element={<Layout><Faculty /></Layout>} />
      <Route path="/history" element={<Layout><History /></Layout>} />
      <Route path="/school-information" element={<Layout><SchoolInfo /></Layout>} />
      <Route path="/school-management" element={<Layout><SchoolManagement /></Layout>} />
      <Route path="/vision-mission" element={<Layout><VisionMission /></Layout>} />
      <Route path="/visiting-dignitaries" element={<Layout><VisitingDigitaries /></Layout>} />
      <Route path="/public-disclosure" element={<Layout><PublicDisclosure /></Layout>} />

      <Route path="/admission-form" element={<Layout><Admission /></Layout>} />
      <Route path="/age-criteria" element={<Layout><AgeCriteria /></Layout>} />
      <Route path="/procedure" element={<Layout><AdmissionProcess /></Layout>} />
      <Route path="/fee-structure" element={<Layout><AdmissionFee /></Layout>} />
      <Route path="/requirement" element={<Layout><AdmissionRequirement /></Layout>} />

      <Route path="/senior-secondary" element={<Layout><SeniorSecondary /></Layout>} />
      <Route path="/play-kindergarden" element={<Layout><PlaywayKindergarden /></Layout>} />
      <Route path="/primary-curriculum" element={<Layout><PrimaryCurriculum /></Layout>} />
      <Route path="/middle-curriculum" element={<Layout><MiddleCurriculum /></Layout>} />
      <Route path="/high-curriculum" element={<Layout><HighCurriculum /></Layout>} />
      <Route path="/erp-login" element={<Layout><Erp /></Layout>} />
      <Route path="/secondary-school" element={<Layout><Secondary /></Layout>} />

      <Route path="/classrooms" element={<Layout><Classroom /></Layout>} />
      <Route path="/library" element={<Layout><Library /></Layout>} />
      <Route path="/labs" element={<Layout><Labs /></Layout>} />
      <Route path="/sports" element={<Layout><Sports /></Layout>} />
      <Route path="/transportation" element={<Layout><Transportation /></Layout>} />
      <Route path="/healthcare" element={<Layout><HealthCare /></Layout>} />
      <Route path="/music" element={<Layout><Music /></Layout>} />
      <Route path="/co-curricular" element={<Layout><CoCurriculum /></Layout>} />
      <Route path="/education-trips" element={<Layout><EducationTrips /></Layout>} />
      <Route path="/morning-assembly" element={<Layout><MorningAssembly /></Layout>} />
      <Route path="/value" element={<Layout><Value /></Layout>} />
      <Route path="/contact" element={<Layout><Contact /></Layout>} />

      <Route path="/awards" element={<Layout><Awards /></Layout>} />
      <Route path="/playway" element={<Layout><Playway /></Layout>} />
      <Route path="/school-curriculum" element={<Layout><SchoolCurriculum /></Layout>} />
      <Route path="/primary" element={<Layout><PrimaryCurriculum /></Layout>} />
      <Route path="/security" element={<Layout><Security /></Layout>} />
      <Route path="/middle" element={<Layout><MiddleCurriculum /></Layout>} />
      <Route path="/secondary" element={<Layout><HighCurriculum /></Layout>} />
      <Route path="/faqs" element={<Layout><Faqs /></Layout>} />
      <Route path="/career" element={<Layout><Career /></Layout>} />
      <Route path="/feedback" element={<Layout><FeedBack /></Layout>} />
      <Route path="/ptm" element={<Layout><Ptm /></Layout>} />
      <Route path="/school-houses" element={<Layout><SchoolHouse /></Layout>} />
    </Routes>
  );
}

export default App;
